import { render } from "./OrderItem.vue?vue&type=template&id=7e0ea81d&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=7e0ea81d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e0ea81d"

export default script